import gql from 'graphql-tag';

export const locationSearch = gql`
  query locationSearch($query: String!) {
    locationSearch(query: $query, platform: WEB) {
      total
      records {
        id
        name
        description
      }
    }
  }
`;

export const locationData = gql`
  query location($locationId: String!) {
    location(location_id: $locationId, platform: WEB) {
      id
      name
      freeform_address
      address_line_1
      address_line_2
      city
      state {
        long_name
        short_name
      }
      country {
        id
        name
        iso
        iso3
      }
      point {
        latitude
        longitude
      }
    }
  }
`;
